// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading-module--container--JL1vv","containerBorder":"Loading-module--container--border--vf5kC","message":"Loading-module--message--1YVy8"};